import React from 'react';
import PropTypes from 'prop-types';

const UiMorePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0zM6 8a2 2 0 1 0 3.999.001A2 2 0 0 0 6 8zM0 8a2 2 0 1 0 3.999.001A2 2 0 0 0 0 8z"
    />
  );
};

UiMorePath.propTypes = {
  fill: PropTypes.string,
};

export default UiMorePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-more.jsx